{
  "journalAudit.action.platform.identity_provider_configured": "Fournisseur d’identité de la plateforme raccordé",
  "journalAudit.action.platform.instance_updated": "Instance et inscription en libre-service modifiées",
  "journalAudit.action.platform.mail_tested": "Courrier d’essai envoyé",
  "journalAudit.action.platform.outbound_settings_updated": "Flux sortants et courrier sortant modifiés",
  "journalAudit.action.platform.settings_updated": "Paramètres généraux de la plateforme modifiés",
  "journalAudit.action.platform.siem_configured": "Export du journal vers le SIEM enregistré",
  "journalAudit.action.platform.siem_suspended": "Export du journal vers le SIEM suspendu ou repris",
  "journalAudit.action.platform.siem_tested": "Export vers le SIEM essayé"
}
